<template>
  <div class="box">
    <!-- 通用页面头部 -->
    <template v-if="headerStyle == 1">
      <section class='page-nav-box' v-if="config.pc_navigation && config.pc_navigation.left">
        <!-- 导航 -->
        <section :class="newPC ? level1V2 : 'page-nav-level1'">
          <section class='page-nav-level1-main'>
            <el-menu text-color='#fff' active-text-color='#fff' v-for="(item, index) in config.pc_navigation.left" :key="index" class='vleft' mode='horizontal'>
              <el-menu-item v-if="item.hasChildren && item.disabled !== true" :index="`${index}`" :class="showbackground === item.id? 'vnav nav-click' : 'vnav'">
                <el-dropdown @command="handleCommand" @visible-change="handleShow(item)" :show-timeout="0" :hide-timeout="0" placement="bottom-start">
                  <el-button class="el-btn">
                    <span class='page-nav-bar'>
                      {{item.label}}
                      <i class='el-icon-caret-bottom el-icon--right'></i>
                    </span>
                  </el-button>
                  <el-dropdown-menu slot='dropdown'>
                    <div v-for="(option, index) in item.children" :key="index">
                      <el-dropdown-item index='option.id' :command="option.short || option.value" class="my-dropdown-menu-item">
                        <a :target="option.target || '_blank'" :title="option.label" :href="(option.short || option.value) || 'javascript:;'">{{ option.label }}</a>
                      </el-dropdown-item>
                    </div>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-menu-item>
              <el-menu-item v-else-if="item.disabled !== true" class="vtitle" index='item.id'>
                <a :target="item.target || '_blank'" :title="item.label" :href="(item.short || item.value) || 'javascript:;'">{{ item.label }}</a>
              </el-menu-item>
            </el-menu>

            <!-- 右 -->
            <el-menu text-color='#fff' active-text-color='#fff' class='vright' mode='horizontal'>
              <template v-for="(item, index) in config.pc_navigation.right" >
                <el-menu-item :key="'r'+index" v-if="item.hasChildren && item.disabled !== true" :index="`${index}`" :class="showbackground === item.id? 'vnav nav-click' : 'vnav'">
                  <el-dropdown @command="handleCommand" @visible-change="handleShow(item)" :show-timeout="0" :hide-timeout="0" placement="bottom-start">
                    <el-button class="el-btn">
                      <span class='page-nav-bar'>
                        {{item.label}}
                        <i class='el-icon-caret-bottom el-icon--right'></i>
                      </span>
                    </el-button>
                    <el-dropdown-menu slot='dropdown'>
                      <div v-for="(option, index) in item.children" :key="index">
                        <el-dropdown-item index='option.id' :command="option.short || option.value" class="my-dropdown-menu-item">
                          <a :target="option.target || '_blank'" :title="option.label" :href="(option.short || option.value) || 'javascript:;'">{{ option.label }}</a>
                        </el-dropdown-item>
                      </div>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-menu-item>
                <el-menu-item :key="'el'+index" v-else-if="item.disabled !== true" class="vtitle" :index="'r_c'+index" @click="gotoLink(item.short || item.value)">
                  <a :target="item.target || '_blank'" :title="item.label" :href="(item.short || item.value) || 'javascript:;'">{{ item.label }}</a>
                </el-menu-item>
              </template>
              <el-menu-item index='6' class="vwechat">
                <el-dropdown placement="bottom-start" :show-timeout="0" :hide-timeout="0">
                  <el-button class="el-btn">
                    <span class='wechat-text'>
                      服务号
                    </span>
                  </el-button>
                  <el-dropdown-menu slot='dropdown'>
                    <!-- <el-dropdown-item class="wechat-img"><img src="//www.0550.com/images/v3/weixin0550.png" alt=""></el-dropdown-item> -->
                    <el-dropdown-item class="wechat-img"><img :src="config.wechat_qrcode" alt=""></el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-menu-item>

              <el-menu-item index='10' :class="showbackground === 10 ? 'user nav-click' : 'user'">
                <!-- 修复jobseek跳转过来vuex丢失，导致用户状态丢失 -->
                <!-- <span v-if="!$store.getters.user.type" class="nologin"> -->
                <el-dropdown @command="handleUserLink" @visible-change="handleShow(10)" :show-timeout="0" :hide-timeout="0" placement="bottom-end">
                  <el-button class="el-btn">
                    <span class="username">
                      {{userData.username}}
                      <i class='el-icon-caret-bottom el-icon--right'></i>
                    </span>
                  </el-button>
                  <el-dropdown-menu slot='dropdown'>
                    <el-dropdown-item command="center" class="my-top">进入个人中心</el-dropdown-item>
                    <el-dropdown-item command="resume" class="my-nav">我的简历<span class="my-nav-edit">编辑</span></el-dropdown-item>
                    <el-dropdown-item command="send-log" class="my-nav">投递记录</el-dropdown-item>
                    <el-dropdown-item command="care" class="my-nav">关注我的<span :class="userData.followme_count && userData.followme_count > 0 ? 'my-nav-number1' : 'my-nav-number2'">{{userData.followme_count}}</span></el-dropdown-item>
                    <el-dropdown-item command="QuitSystem" class="my-footer">退出登录</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-menu-item>
            </el-menu>
          </section>
        </section>
        <!-- 关联 -->
        <section :class="newPC ? level2V2 : 'page-nav-level2'">
          <el-row class='page-nav-level2-bar'>
            <img class='logo' :src='config.logo_url' alt='' @click="gotoLink('/')" style="cursor:pointer; hieght:60px;">
            <el-menu background-color='transparent' class='page-nav-level2-list' mode='horizontal'>
              <template v-for="(item, index) in config.pc_navigation.primary">
                <el-menu-item index='item.id' :key="'p'+index" v-if="item.disabled !== true">
                  <a :target="item.target || '_blank'" :title="item.label" :href="(item.short || item.value) || 'javascript:;'">{{ item.label }}</a>
                </el-menu-item>
              </template>
            </el-menu>
          </el-row>
        </section>
      </section>

      <!-- 旧导航 -->
      <section class='page-nav-box' v-else>
        <!-- 导航 -->
        <section :class="newPC ? level1V2 : 'page-nav-level1'">
          <section class='page-nav-level1-main'>
            <el-menu text-color='#fff' active-text-color='#fff' v-for="(item, index) in this.topLeftNav" :key="index" background-color='#4A88F7' class='vleft' mode='horizontal'>
              <el-menu-item v-if="item.chindren" index='item.id' :class="showbackground === item.id? 'vnav nav-click' : 'vnav'">
                <el-dropdown @command="handleCommand" @visible-change="handleShow(item.id)" :show-timeout="0" :hide-timeout="0" placement="bottom-start">
                  <el-button class="el-btn">
                    <span class='page-nav-bar'>
                      {{item.title}}
                      <i class='el-icon-caret-bottom el-icon--right'></i>
                    </span>
                  </el-button>
                  <el-dropdown-menu slot='dropdown'>
                    <div v-for="(option, index) in item.chindren" :key="index">
                      <el-dropdown-item index='option.id' :command="option.url" class="my-dropdown-menu-item">{{option.title}}</el-dropdown-item>
                    </div>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-menu-item>
              <el-menu-item v-else class="vtitle" index='item.id' @click="gotoLink(item.url)">{{item.title}}</el-menu-item>
            </el-menu>
            <el-menu text-color='#fff' active-text-color='#fff' background-color='#4A88F7' class='vright' mode='horizontal'>
              <el-menu-item v-if="showweibo" index='5' class="vweibo" @click="gotoLink(weiboUrl)">微博</el-menu-item>
              <el-menu-item v-if="showwechat" index='6' class="vwechat">
                <el-dropdown placement="bottom-start" :show-timeout="0" :hide-timeout="0">
                  <el-button class="el-btn">
                    <span class='wechat-text'>
                      微信
                    </span>
                  </el-button>
                  <el-dropdown-menu slot='dropdown'>
                    <!-- <el-dropdown-item class="wechat-img"><img src="//www.0550.com/images/v3/weixin0550.png" alt=""></el-dropdown-item> -->
                    <el-dropdown-item class="wechat-img"><img :src="config.wechat_qrcode" alt=""></el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-menu-item>
              <el-menu-item v-for="(item, index) in this.rightNav" :key="index" index="item.id" class="rightnav" @click="gotoLink(item.url)">{{item.title}}</el-menu-item>
              <el-menu-item index='10' :class="this.showbackground === 10 ? 'user nav-click' : 'user'">
                <!-- 修复jobseek跳转过来vuex丢失，导致用户状态丢失 -->
                <!-- <span v-if="!$store.getters.user.type" class="nologin"> -->
                <span v-if="!userData.type" class="nologin">
                  <span class="login-text">登录</span><span>注册</span>
                </span>
                <el-dropdown v-else @command="handleUserLink" @visible-change="handleShow(10)" :show-timeout="0" :hide-timeout="0" placement="bottom-end">
                  <el-button class="el-btn">
                    <span class="username">
                      {{userData.username}}
                      <i class='el-icon-caret-bottom el-icon--right'></i>
                    </span>
                  </el-button>
                  <el-dropdown-menu slot='dropdown' v-if="userData.type === 1">
                    <el-dropdown-item command="center" class="my-top">进入个人中心</el-dropdown-item>
                    <el-dropdown-item command="resume" class="my-nav">我的简历<span class="my-nav-edit">编辑</span></el-dropdown-item>
                    <el-dropdown-item command="send-log" class="my-nav">投递记录</el-dropdown-item>
                    <el-dropdown-item command="care" class="my-nav">关注我的<span :class="userData.followme_count && userData.followme_count > 0 ? 'my-nav-number1' : 'my-nav-number2'">{{userData.followme_count}}</span></el-dropdown-item>
                    <el-dropdown-item command="QuitSystem" class="my-footer">退出登录</el-dropdown-item>
                  </el-dropdown-menu>
                  <el-dropdown-menu slot='dropdown' v-if="userData.type === 2">
                    <el-dropdown-item command="enterprise-center" class="my-top">进入企业中心</el-dropdown-item>
                    <el-dropdown-item command="tapPublishJob" class="my-nav">发布职位</el-dropdown-item>
                    <el-dropdown-item command="enterprise-resume" class="my-nav">查收简历</el-dropdown-item>
                    <el-dropdown-item command="enterprise-recruit" class="my-nav">在招职位<span :class="company.info_num > 0 ? 'my-nav-number1' : 'my-nav-number2'">{{company.info_num}}</span></el-dropdown-item>
                    <el-dropdown-item command="enterprise-resume" class="my-nav">未查看简历<span :class="company.not_view_resumes > 0 ? 'my-nav-number1' : 'my-nav-number2'">{{company.not_view_resumes}}</span></el-dropdown-item>
                    <el-dropdown-item command="QuitSystem" class="my-footer">退出登录</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-menu-item>
            </el-menu>
          </section>
        </section>
        <!-- 关联 -->
        <section :class="newPC ? level2V2 : 'page-nav-level2'">
          <el-row class='page-nav-level2-bar'>
            <img class='logo' :src='config.logo_url' alt='' @click="gotoLink('/')" style="cursor:pointer; hieght:60px;">
            <el-menu background-color='transparent' v-for="(item, index) in this.mainnav" :key="index" class='page-nav-level2-list' mode='horizontal'>
              <el-menu-item index='item.id' @click="gotoLink(item.url)"><span>{{item.title}}</span></el-menu-item>
            </el-menu>
          </el-row>
        </section>
      </section>
    </template>
    <!-- 注册页面头部 -->
    <section class="page-nav2-box" v-if="headerStyle == 2">
      <header class="nav-type-two">
        <img @click="tapHrefHome" class='logo' :src='config.logo_url' alt=''>
        <div class="v-hrefBox">
          <button @click="tapHrefHome">首页</button>
          <button @click="tapHrefCall">联系客服</button>
        </div>
      </header>
    </section>
  </div>
</template>

<script>
// 资源
import imgLogo from '$img/Elogo.png';
import wxImgLogo from '$img/personal/wxcode.png';
import Cookies from 'js-cookie';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      imgLogo,
      wxImgLogo,
      showbackground: 0,
      info: {},
      topLeftNav: {},
      topRightNav: {},
      rightNav: [],
      mainnav: {},
      showweibo: false,
      weiboUrl: false,
      showwechat: false,
      userData: {},
      newPC: false,
      level1V2: 'page-nav-level1 page-nav-level1-v2',
      level2V2: 'page-nav-level2 page-nav-level2-v2'
    };
  },
  computed: {
    ...mapGetters(['config', 'user', 'company'])
  },
  created() {
    this.pcVersion()
    this.getNavigation();
    this.fetchUser();
  },
  methods: {
    ...mapActions(['setUserInfo', 'setCompanyInfo', 'setResumeRefreshClose', 'editRecruitItem']),
    async pcVersion() {
      const res = await this.$api.webConfig.getWebPcVer();
      this.newPC = res === 'v2'
    },
    // 获取用户信息
    async fetchUser() {
      try {
        const res = await this.$api.personalCenter.getUserInfo();
        this.$set(this, 'userData', res);
      } catch (err) {
        console.log(err.message);
        window.location = '/account/login?ref=' + encodeURIComponent(window.location.href);
      }
    },
    QuitSystem() {
      Cookies.set('token', '');
      this.$store.dispatch('setUserInfo', {});
      this.$store.dispatch('setCompanyInfo', {});
      this.setResumeRefreshClose(false);
      window.location = location.origin
        ? location.origin
        : location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
    },
    /* 跳转首页 */
    tapHrefHome() {
      this.$notify({
        title: '跳转',
        message: '跳转到主页'
      });
    },
    /* 联系客户 */
    tapHrefCall() {
      this.$notify({
        title: '跳转',
        message: '跳转到联系客服'
      });
    },
    getNavigation() {
      this.$api.webConfig.getNavigation().then(res => {
        this.topLeftNav = res[0].WebNavigations[0].chindren;
        this.topRightNav = res[0].WebNavigations[1].chindren;
        for (let i in this.topRightNav) {
          // this.rightNav.push(this.topRightNav[i])
          if (this.topRightNav[i].title === '微博') {
            this.showweibo = true;
            this.weiboUrl = this.topRightNav[i].url;
          } else if (this.topRightNav[i].title === '微信') {
            this.showwechat = true;
          } else {
            this.rightNav.push(this.topRightNav[i]);
          }
        }
        this.mainnav = res[1].WebNavigations.reverse();
      });
    },
    gotoLink(link) {
      location.href = link;
    },
    handleCommand(link) {
      location.href = link;
    },
    handleUserLink(val) {
      if (val === 'QuitSystem') {
        this.QuitSystem();
      } else if (val === 'tapPublishJob') {
        this.tapPublishJob();
      } else {
        this.$router.push({
          path: val
        });
      }
    },
    async tapPublishJob() {
      const that = this;
      const execute = () => {
        that.editRecruitItem(undefined);
        that.$router.push({
          name: 'EnterprisePublishJob'
        });
      };
      const result = await that.$api.enterpriseRecruit.createUpdateCount();
      if (result.code) {
        if (result.code === 527) {
          this.$confirm(result.message, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          })
            .then(() => {
              execute();
            })
            .catch(() => {});
        } else {
          this.$confirm(result.message, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          });
        }
      } else {
        execute();
      }
    },
    handleShow(val) {
      if (this.showbackground !== val) {
        this.showbackground = val;
      } else {
        this.showbackground = 0;
      }
    }
  },
  props: {
    headerStyle: {
      default: 1
    }
  }
};
</script>

<style lang='less' scoped>
.el-menu-item {
  :hover {
    background: transparent;
  }
}
.el-btn {
  background: transparent;
  border: none;
  padding: 10px 0;
}
@import '~$css/var.less';
@imgUrl: '../assets/images/header';
@media print {
  .page-nav-box {
    display: none;
  }
  .page-nav2-box {
    display: none;
  }
}
.page-nav-box {
  width: 100%;
}
.page-nav-level1 {
  width: 100%;
  background: @primary;
  height: 36px;
  .el-menu {
    background-color: #4A88F7;
  }
}
.page-nav-level1-main {
  width: 1150px;
  margin: 0 auto;
  height: 36px;
  border-bottom: 0;
}
.page-nav-level1-main .vtitle {
  font-size: 14px;
  padding: 0;
  padding-right: 15px !important;
  padding-left: 15px !important;
  background: transparent !important;
}
.page-nav-level1-main .vtitle:hover {
  background: #3374e9;
}
.page-nav-level1-main .vleft:first-child .vtitle {
  margin-left: -10px;
  padding-left: 10px;
}
.page-nav-level1-main .vleft {
  float: left;
}
.page-nav-level1-main .vright {
  float: right;
}
.page-nav-level1-main .el-menu--horizontal > .el-menu-item {
  height: 36px;
  line-height: 36px;
  font-family: 'Microsoft Yahei', 'PingFang SC';
}
.page-nav-level1 .el-menu-item {
  padding: 0;
  background: transparent !important;
}
.page-nav-level1 .nav-click {
  background: #3374e9;
}
// .page-nav-level1 .vnav {
// padding-left: 15px;
// margin-right: 15px;
// }
.page-nav-level1 .vbbs {
  margin-left: 15px;
}
.page-nav-level1 .rightnav {
  position: relative;
  padding-right: 15px;
  padding-left: 15px;
}
.page-nav-level1 .rightnav:hover {
  background: #3374e9;
}
.page-nav-level1 .vweibo {
  position: relative;
  padding-right: 15px;
  padding-left: 40px;
}
.page-nav-level1 .vweibo:hover {
  background: #3374e9;
}
.page-nav-level1 .vweibo::after {
  content: '';
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translate(0, -50%);
  width: 17px;
  height: 17px;
  background: transparent url('@{imgUrl}/weibo.svg') no-repeat center center / contain;
}
.page-nav-level1 .user {
  padding: 0 0 0 32px;
  margin-right: -10px;
}
.page-nav-level1 .user::after {
  content: '';
  position: absolute;
  left: 13px;
  top: 50%;
  transform: translate(0, -50%);
  width: 14px;
  height: 14px;
  background: transparent url('@{imgUrl}/user.svg') no-repeat center center / contain;
}
.page-nav-level1 .username {
  position: relative;
  top: -2px;
  color: #fff !important;
}
.page-nav-level1 .vwechat {
  padding-right: 15px;
  // padding-left: 20px;
}
.page-nav-level1 .vwechat:hover {
  background: #3374e9;
}
.page-nav-level1 .vlogin {
  margin-right: 66px;
}
.page-nav-level1 .vwechat::after {
  content: '';
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translate(0, -50%);
  width: 17px;
  height: 17px;
  background: transparent url('@{imgUrl}/wechat.svg') no-repeat center center / contain;
}
.page-nav-level1 .page-nav-bar {
  color: @primary-font;
  vertical-align: text-top;
  padding-left: 15px;
}
.page-nav-level1 .wechat-text {
  padding-left: 40px;
  color: @primary-font;
  vertical-align: text-top;
}
.page-nav-level1 .page-nav-bar .el-menu-item {
  margin-right: 0;
}
.page-nav-level1 .vchannel {
  padding-left: 15px;
  margin-right: 15px;
}
.page-nav-level1 .el-menu-item i {
  color: @primary-font;
}
.page-nav-level1 .el-icon--right {
  margin-left: -7px;
  font-size: 8px;
}
.page-nav-level1-v2{
  background-color: #212736;
  border-bottom: none;
  .el-menu {
    background-color: #212736;
  }
  .vweibo:hover {
    background-color: #ffffff !important;
  }
  .el-menu.el-menu--horizontal {
    border-bottom: none;
  }
}
.page-nav-level2-v2{
  background: #4A88F7 !important;
  border-bottom: none;
  .el-menu--horizontal>.el-menu-item {
    color: #ffffff !important;
  }
}
.page-nav-level2 {
  width: 100%;
  height: 70px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
  background: #fff;
}
.page-nav-level2-bar {
  position: relative;
  width: 1150px;
  margin: 0 auto;
  // overflow: hidden;
}
.page-nav-level2-list {
  float: right;
  border-bottom: 0;
}
.page-nav-level2-list.el-menu--horizontal > .el-menu-item {
  height: 70px;
  line-height: 70px;
  font-weight: bold;
  font-size: 16px;
  font-family: 'Microsoft Yahei', 'PingFang SC';
}
.page-nav-level2-list.el-menu--horizontal > .el-menu-item {
  padding: 0;
  margin: 0 0 0 40px;
}
.page-nav-level2-list.el-menu--horizontal > .el-menu-item:hover {
  color: #4a88f7;
}
.page-nav-level2-list.el-menu--horizontal > .el-menu-item:hover span::after {
  content: '';
  width: 18px;
  height: 3px;
  background: #3388ff;
  display: block;
  margin: -13px auto;
  color: #4a88f7;
}
.page-nav-level2-bar .logo {
  position: absolute;
  height: 50px;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  display: block;
  float: left;
}
/* page-nav-level2 */
.page-nav-level2 .el-menu--horizontal > .el-menu-item {
  background: transparent !important;
  border: none;
  color: rgba(51, 51, 51, 1);
}
/* page-nav2-box */
.page-nav2-box {
  width: 100%;
  height: 70px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 1px 0px 0px rgba(221, 221, 221, 1);
}
.nav-type-two {
  width: 1150px;
  margin: 0 auto;
}
.nav-type-two img {
  width: 181px;
  height: 30px;
  float: left;
  margin-top: 20px;
}
.nav-type-two .v-hrefBox {
  float: right;
}
.nav-type-two .v-hrefBox button {
  font-size: 16px;
  font-family: PingFangSC-Light;
  color: rgba(51, 51, 51, 1);
  line-height: 70px;
  background: transparent;
  border: 0;
  margin-left: 55px;
  cursor: pointer;
}
.nav-type-two .v-hrefBox button:focus {
  outline: 0;
}
.el-dropdown-menu {
  // padding: 8px 0  5px 0;
  padding: 0;
  position: absolute !important;
  top: 24px !important;
  border-radius: none;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
  border: 1px solid #e9e9f0;
}
.el-dropdown-menu__item {
  line-height: 30px;
  // margin: 2px 0;
}
.el-dropdown-menu__item:hover {
  background: #f9f9f9;
}
.my-dropdown-menu-item {
  width: 120px;
  float: left;
  padding-left: 15px;
}
.my-top {
  padding-left: 15px;
  padding-right: 15px;
  height: 46px;
  line-height: 46px;
  width: 168px;
  margin: 0;
  // margin-bottom: 5px;
}
.my-top::after {
  content: '';
  position: absolute;
  top: 46px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 138px;
  height: 1px;
  background: #f5f5f5;
}
.my-nav {
  height: 35px;
  line-height: 35px;
  padding-left: 15px;
  padding-right: 15px;
  margin: 0;
}
.my-nav-number1 {
  float: right;
  line-height: 30px;
  color: #fe6135;
}
.my-nav-number2 {
  float: right;
  line-height: 30px;
  color: #cccccc;
}
.my-nav-edit {
  float: right;
  line-height: 30px;
  color: #6e86b1;
}
.my-footer {
  padding-left: 15px;
  padding-right: 15px;
  height: 46px;
  line-height: 46px;
  margin: 0;
  // margin-top: 5px;
  color: #999999;
}
.my-footer::after {
  content: '';
  position: absolute;
  bottom: 46px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 138px;
  height: 1px;
  background: #f5f5f5;
}
.nologin {
  vertical-align: middle;
  position: relative;
  top: -2px;
}
.login-text {
  margin-right: 15px;
}
.login-text::after {
  content: '';
  position: absolute;
  width: 1px;
  height: 14px;
  background: #ffffff;
  top: 4px;
  right: 35px;
}
.wechat-img {
  text-align: center;
  padding: 15px;
  margin: 0;
  width: 150px;
  height: 150px;
}
.wechat-img img {
  width: 120px;
  height: 120px;
}
</style>
<style>
.el-popper .popper__arrow {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue